// src/components/Fruits/FruitCard.jsx
import React from 'react';
import {
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Typography,
  Button,
  Chip,
  Box,
  IconButton,
} from '@mui/material';
import {
  ShoppingCart,
  Info,
  WhatsApp,
  LocationOn,
  Scale,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { formatCurrency } from '../../utils/helpers';

const FruitCard = ({ fruit }) => {
  const navigate = useNavigate();

  const handleEnquiry = () => {
    navigate(`/fruits/${fruit.id}`);
  };

  const handleWhatsApp = () => {
    const message = `Hello, I'm interested in ${fruit.name} (${fruit.variety}) from ${fruit.origin_country}.`;
    const whatsappUrl = `https://wa.me/1234567890?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const imageUrl = fruit.image_url || `http://localhost:5000${fruit.image_url}` || '/default-fruit.jpg';

  return (
    <Card sx={{ 
      height: '100%', 
      display: 'flex', 
      flexDirection: 'column',
      transition: 'transform 0.2s, box-shadow 0.2s',
      '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: 6,
      },
    }}>
      <CardMedia
        component="img"
        height="200"
        image={imageUrl}
        alt={fruit.name}
        sx={{ objectFit: 'cover' }}
      />
      <CardContent sx={{ flexGrow: 1 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', mb: 1 }}>
          <Typography gutterBottom variant="h6" component="div" sx={{ lineHeight: 1.2 }}>
            {fruit.name}
          </Typography>
          <Chip label={fruit.grade || 'Standard'} color="primary" size="small" />
        </Box>
        
        <Typography variant="body2" color="text.secondary" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Scale fontSize="small" />
          Variety: {fruit.variety || 'N/A'}
        </Typography>
        
        <Typography variant="body2" color="text.secondary" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <LocationOn fontSize="small" />
          Origin: {fruit.origin_country || 'N/A'}
        </Typography>
        
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 1, mb: 2 }}>
          <Chip 
            label={`Size: ${fruit.size || 'N/A'}`} 
            size="small" 
            variant="outlined" 
          />
          <Chip 
            label={`MOQ: ${fruit.moq || 1}`} 
            size="small" 
            variant="outlined" 
          />
        </Box>
        
        {fruit.price_per_unit && (
          <Typography variant="h6" color="primary" sx={{ mt: 'auto' }}>
            {formatCurrency(fruit.price_per_unit)}/unit
          </Typography>
        )}
      </CardContent>
      
      <CardActions sx={{ p: 2, pt: 0, justifyContent: 'space-between' }}>
        <IconButton 
          onClick={() => navigate(`/fruits/${fruit.id}`)} 
          color="info"
          size="small"
        >
          <Info />
        </IconButton>
        
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            variant="outlined"
            size="small"
            startIcon={<WhatsApp />}
            onClick={handleWhatsApp}
            sx={{ whiteSpace: 'nowrap' }}
          >
            WhatsApp
          </Button>
          
          <Button
            variant="contained"
            size="small"
            startIcon={<ShoppingCart />}
            onClick={handleEnquiry}
            sx={{ whiteSpace: 'nowrap' }}
          >
            Enquire
          </Button>
        </Box>
      </CardActions>
    </Card>
  );
};

export default FruitCard;